import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { IPilot, IPilotForm } from 'src/models/pilot.model';
import { usePilotContext } from 'src/contexts/pilot.context';
import Lang from 'src/libraries/language';
import { actionTypes } from 'src/ducks/pilot.duck';
import { getPilotStatus } from 'src/selectors/pilot.selector';
import PilotsForm from '../pilots-form/pilots-form.component';
import style from '../pilots-list/pilots-list.module.scss';

type IProp = {
  data: IPilot;
};

const PilotsEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = usePilotContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<IPilot> = {
    name: '',
    phone: '',
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getPilotStatus(state, actionTypes.PILOT_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IPilotForm = {
        name: value.name,
        phone: value.phone,
      };
      const response = await actions.updatePUT(value.pilotId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_PILOT_EDIT_SUCCESS,
            formData.name ? formData.name : value.name
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_EDIT_PILOT}
      content={
        <div className={style.content}>
          <PilotsForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default PilotsEdit;
